<template>
	<div class="c-block-list-rte">
		<h2
			v-if="title"
			class="font-medium mb-[10px] text-[20px]"
			v-html="title"
		></h2>
		<div v-if="text" class="s-rich-text" v-html="text"></div>
	</div>
</template>

<script setup>
defineProps({
	title: String,
	text: String,
});
</script>
<script>
export default {
	inheritAttrs: false,
};
</script>

<style lang="postcss">
.c-block-list-rte {
	@apply bg-white text-text <760:p-[15px] p-[25px];
}
</style>
